import { cn } from '@typedream/ui';
import * as React from 'react';
import styles from './DreamEditorWrapper.module.css';

export interface DreamEditorWrapperProps extends React.ComponentPropsWithoutRef<'div'> {
  loadEditorFonts?: boolean;
}

export function DreamEditorWrapper({
  className,
  children,
  loadEditorFonts,
  ...rest
}: DreamEditorWrapperProps) {
  return (
    <div className={cn(styles.root, className)} {...rest}>
      {children}
    </div>
  );
}
